import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { api } from "@/lib/api";
import { Kicker } from "@/components/form";

export function Reviews() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/reviews").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (items.length === 0) return null;
  return (
    <section className="bg-navy-900 py-20 lg:py-28" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl"><Kicker>Kundenstimmen</Kicker><h2 className="mt-4 text-3xl sm:text-4xl font-bold tracking-tight text-white">Vertrauen, das man weiterempfiehlt.</h2></div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.slice(0, 6).map((r, i) => (
            <motion.div key={r.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="bg-navy-800 border border-white/5 rounded-md p-7">
              <Quote className="text-gold-500/40" size={28} />
              <div className="flex gap-0.5 mt-3">{Array.from({ length: r.rating }).map((_, k) => <Star key={k} size={15} className="text-gold-500 fill-gold-500" />)}</div>
              <p className="mt-4 text-slate-300 leading-relaxed text-sm">„{r.text}"</p>
              <p className="mt-5 text-white font-semibold text-sm">{r.name}</p>
              {r.area && <p className="text-xs text-gold-500">{r.area}</p>}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
